<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> 
  </nav> -->

  <van-nav-bar
    title="数字企业移动端"
    v-if="showNavBar"
    style="background-color: #5e85e7"
  />

  <router-view />
</template>
<script setup>
import { ref, watchEffect } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
const showNavBar = ref(true);

// 监听路由变化
watchEffect(() => {
  // 如果当前路由是登录页，则隐藏导航栏
  showNavBar.value = route.name !== "Login";
});
</script>

<style>
/* #app {
  background-color: #f0f2f5;
} */

/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
